<template>
  <section id="allegati">

    <b-list-group>
      <b-list-group-item
        v-for="(file, idx) in files"
        :key="idx"
        class="d-flex"
        @click="DownloadFile(file.fullpath)"
      >
        <span class="mr-1">
          <feather-icon
            icon="DownloadIcon"
            size="16"
          />
        </span>
        <span>{{ file.name }}</span>
      </b-list-group-item>
    </b-list-group>


  </section>
</template>

<script>
/* eslint-disable vue/no-unused-components */
/* eslint no-unused-expressions: ["error", { "allowShortCircuit": true }] */
import Vue from 'vue'
import { VueAutosuggest } from 'vue-autosuggest'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import {
  BAvatar, BModal, BButton, VBModal, BTable, BCardBody, BCardFooter, BOverlay, BFormFile, BCard, BListGroup,
  BListGroupItem, BCol, BRow,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import { useRouter } from '@core/utils/utils'
import { getUserData } from '@/auth/utils'
import {
  ref, onUnmounted, computed, watch,
} from '@vue/composition-api'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import storeModule from '../../../store/app/baseStoreModule'

export default {
  components: {
    BCardActions,
    BFormFile,
    BButton,
    BListGroup,
    BListGroupItem,
    BModal,
    BCard,
    BCardBody,
    BTable,
    VueAutosuggest,
    BCol,
    BRow,
    BAvatar,
    BCardFooter,
    BOverlay,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  props: {
    productList: { type: [], default: [] },


  },
  setup(props, { emit }) {
    const files = ref([])
    const show = ref(false)
    const APP_STORE_MODULE_NAME = 'app-base'

    // Register module
    if (!store.hasModule(APP_STORE_MODULE_NAME)) store.registerModule(APP_STORE_MODULE_NAME, storeModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(APP_STORE_MODULE_NAME)) store.unregisterModule(APP_STORE_MODULE_NAME)
    })
    const userData = getUserData()
    const fetchFiles = () => {
      console.log("Festch file", props.productList)
      show.value = true
      // eslint-disable-next-line no-restricted-syntax
      for (const product of props.productList) {
        store.dispatch(`${APP_STORE_MODULE_NAME}/fetchFileList`, { linkedObject: product.linkedObject, linkedId: product.linkedId })
          .then(res => {
            // eslint-disable-next-line no-restricted-syntax
            for (const f of res.data.files) {
              files.value.push(f)
            }
          })
          .catch(error => {
            console.log('erro files', error)
          }).finally(show.value = false)
      }
    }
    const DownloadFile = fullpath => {
      store.dispatch(`${APP_STORE_MODULE_NAME}/fetchFile`, { fullpath })
        .then(res => {
          if (res.data.Data) {
            const binaryString = window.atob(res.data.Data.base64String)
            const bytes = new Uint8Array(binaryString.length)
            const mappedData = bytes.map((byte, i) => binaryString.charCodeAt(i))
            const blob = new Blob([mappedData], { type: res.data.Data.file.mimetype })
            const fileURL = window.URL.createObjectURL(blob)
            const fileLink = document.createElement('a')
            fileLink.href = fileURL
            fileLink.setAttribute('download', res.data.Data.file.name)
            document.body.appendChild(fileLink)
            fileLink.click()
            URL.revokeObjectURL(fileURL)
          } else {
            Vue.prototype.$toast({
              component: ToastificationContent,
              props: {
                title: 'File danneggiato. Ripristinare il file nel pannello di configurazione',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
        .catch(error => {
          console.log(error)
        })
    }
    watch(props, () => {
      fetchFiles()
    })
    fetchFiles()
    return {
      userData,
      files,
      fetchFiles,
      show,
      DownloadFile,
    }
  },
  methods: {
    formatDateTime(formatedDate) {
      if (formatedDate) {
        const date = new Date(formatedDate) // formated_Date - SDK returned date

        return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`
      } return ""
    },
  },
}


</script>
